import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import PnLCard from "./PnLCardSM.jsx";
import { WalletOutlined, StarOutlined, RiseOutlined } from "@ant-design/icons";
import { GetAccountSummaryApi } from "../../../../api/request/dashboard.js";

const PnLCardGridSM = ({ loginId }) => {
  const [data, setData] = useState(null);

  const pnlCards = [
    {
      type: "Total Equity",
      amount: data?.equity || 0,
      color: "bg-blue-500",
      gradient: "from-[#FAF5FF] to-[#ffff]",
      icon: <WalletOutlined size={20} color="#fff" className="text-white" />,
    },
    {
      type: "Total Profit",
      amount: data?.profit || 0,
      color: "bg-green-500",
      gradient: "from-[#F0FDF4] to-[#ffff]",
      icon: <RiseOutlined size={20} color="#fff" className="text-white" />,
    },
    {
      type: "Used Margin",
      amount: data?.usedMargin || 0,
      color: "bg-teal-500",
      gradient: "from-[#FFF7ED] to-[#ffff]",
      icon: <StarOutlined size={20} color="#fff" className="text-white" />,
    },
    {
      type: "Free Margin",
      amount: data?.freeMargin || 0,
      color: "bg-red-500",
      gradient: "from-[#FFEDED] to-[#ffff]",
      icon: <StarOutlined size={20} color="#fff" className="text-white" />,
    },
  ];

  const getAccountSummary = async () => {
    try {
      const { data } = await GetAccountSummaryApi(loginId);
      if (data?.success) setData(data?.data);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
    }
  };

  useEffect(() => {
    if (loginId) getAccountSummary();
  }, [loginId]);

  return (
    <div className="grid grid-cols-4 gap-3">
      {pnlCards.map((card, index) => (
        <PnLCard
          key={card.id || index}
          type={card.type}
          amount={card.amount}
          color={card.color}
          gradient={card.gradient}
          icon={card.icon}
        />
      ))}
    </div>
  );
};

export default PnLCardGridSM;
